import React from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { Button, CardActions } from '@one-thd/sui-atomic-components';
import { showBelowSmBreakpoint } from '../../constants/responsiveClassNames';
import ListsHeader from './ListsHeader';
import { useContainerWidth } from '../../hooks/useContainerWidth';
import ListCarousel from './ListCarousel';
import ListsCompactList from './ListsCompactList';
import { NAVIGATION_URLS } from '../../constants/navigationUrls';

const { arrayOf, number, shape, bool } = proptypes;

const ActionButtons = ({ isCompactView }) => {
  return (isCompactView ? (
    <div className={classNames(showBelowSmBreakpoint, 'sui-mt-auto')}>
      <CardActions>
        <Button fullWidth href={NAVIGATION_URLS.VIEW_ALL_LISTS}>View All Lists</Button>
      </CardActions>
    </div>
  ) : null);
};

const ListsContainer = ({ list, maxMobileListSize, iconSize, componentId }) => {

  const [containerRef, width] = useContainerWidth();
  const isCompactView = width < 376; // sm breakpoint
  const headerActions = isCompactView ? ['createNew'] : ['createNew', 'viewAll'];

  return (
    <div
      ref={containerRef}
      data-testid="lists-container"
      id="user-lists-v2"
      className="sui-@container sui-h-full sui-flex sui-flex-col sui-justify-start sui-grow sui-gap-4"
    >
      <ListsHeader actions={headerActions} />
      {isCompactView ? (
        <div>
          <ListsCompactList
            lists={list}
            iconSize={iconSize}
            maxMobileListSize={maxMobileListSize}
          />
        </div>
      ) : (
        <div>
          <ListCarousel
            lists={list}
            iconSize={iconSize}
            componentId={componentId}
          />
        </div>
      )}
      <ActionButtons isCompactView={isCompactView} />
    </div>
  );
};

ListsContainer.propTypes = {
  list: arrayOf(shape({})),
  maxMobileListSize: number,
  iconSize: proptypes.string,
  componentId: proptypes.string
};
ListsContainer.defaultProps = {
  list: [],
  maxMobileListSize: 4,
  iconSize: 'small',
  componentId: undefined
};

ActionButtons.propTypes = {
  isCompactView: bool
};

ActionButtons.defaultProps = {
  isCompactView: true
};
export default ListsContainer;
